import { NotificationBadge } from "@/pages/notification-list/ui/notification-list/items/notification-badge";
import { NotificationDetail } from "@/pages/notification-list/ui/notification-list/items/notification-detail";
import { NotificationMessage } from "@/pages/notification-list/ui/notification-list/items/notification-message";
import { NotificationTime } from "@/pages/notification-list/ui/notification-list/items/notification-time";
import { NotificationTypeLabel } from "@/pages/notification-list/ui/notification-list/items/notification-type-label";
import { Stack, useTheme } from "@mui/material";
import { Link } from "@tanstack/react-router";
import type { FreightMatching } from "@x-mile/api-contract";

type Props = {
  notification: FreightMatching.schemas.Notification;
  draftOfferCargo?: FreightMatching.schemas.OfferCargo;
  deliveryProposalOfferCargo?: FreightMatching.schemas.OfferCargo;
  contractOfferCargo?: FreightMatching.schemas.OfferCargo;
  readNotification: (id: number) => Promise<void>;
};

export const NotificationRow = ({
  notification,
  deliveryProposalOfferCargo,
  readNotification,
}: Props) => {
  const theme = useTheme();

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      alignItems="flex-start"
      spacing={{ xs: 1, sm: 2 }}
      padding={2}
      component={Link}
      to={`/notifications/${notification.id}`}
      sx={{
        color: "initial",
        textDecoration: "none",
        "&:not(:first-of-type)": {
          borderTop: `1px solid ${theme.palette.grey[200]}`,
        },
      }}
      onClick={() => !notification.isRead && readNotification(notification.id)}
    >
      <Stack
        direction={{ xs: "row-reverse", sm: "row" }}
        alignItems="center"
        width={{ xs: "100%", sm: "initial" }}
      >
        <Stack
          direction={{ xs: "row-reverse", sm: "row" }}
          alignItems="center"
          spacing={1}
          width={{ xs: "100%", sm: 80 }}
          height={{ xs: "initial", sm: 28 }}
        >
          {/* 未読バッジ */}
          <NotificationBadge isRead={notification.isRead} />

          {/* 時間 */}
          <NotificationTime
            date={new Date(notification.createdAt)}
            isRead={notification.isRead}
          />
        </Stack>

        {/* 通知種別のラベル */}
        <NotificationTypeLabel type={notification.payload.type} />
      </Stack>

      <Stack
        spacing={0.5}
        justifyContent="center"
        sx={{
          /* 詳細がない場合でも一定の高さを確保する */
          minHeight: { xs: "initial", sm: 28 },
        }}
      >
        {/* 通知のメッセージ */}
        <NotificationMessage
          message={notification.message}
          isRead={notification.isRead}
        />

        {/* 通知の詳細 */}
        <NotificationDetail
          payload={notification.payload}
          deliveryProposalOfferCargo={deliveryProposalOfferCargo}
        />
      </Stack>
    </Stack>
  );
};
